// extracted by mini-css-extract-plugin
export default {"container":"ChangePassword_container__2G-EM","form":"ChangePassword_form__mNtQH","formButton":"ChangePassword_formButton__OQqKt","cancelButton":"ChangePassword_cancelButton__9GIRd"};